// Add step
function add(name, callback = null) {
  this.steps.push({ name: name, callback: callback });
  this.setState({ ready: true });
  return;
}

export { add };
